import React, { useState, useContext, useEffect } from "react";
import {
  Card,
  CardContent,
  Typography,
  Button,
  FormGroup,
  Grid,
  Paper,
  TextField,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  FormControl,
  MenuItem,
  Select,
  DialogTitle,
  Box,
  IconButton,
} from "@material-ui/core";
import { v4 as uuidv4 } from "uuid";
import axios from "axios";
import { withRouter } from "react-router-dom";
import { Close } from "@material-ui/icons";
import { LoadingContext } from "../../../../context/spinnerContext";

const TopologyCart = ({
  cartItems,
  modelOpts,
  clearCart,
  onRemoveFromCart,
  onGroupCreationSuccess,
  history,
  handleClose,
  fctw
}) => {
  const query = new URLSearchParams(window.location.search);
  const openLoopType=query.get("open-loop-type");
  const { setIsLoading } = useContext(LoadingContext);
  const [selectValue, setSelectValue] = useState(null);
  const [cadGroupName, setCadGroupName] = useState("");
  const [groupNumber, setGroupNumber] = useState("");
  const [openDialog, setOpenDialog] = useState(false);

  console.log("RECEIVED NEW PROPS", cartItems);
  const handleSelectChange = (event) => {
    const newSelectValue = event.target.value;
    setSelectValue(newSelectValue);
  };

  const handleCreateGroup = () => {
    const scenarioGroupUUID = uuidv4();

    const listOfGroups = cartItems.map((item) => ({
      scenario_group_name: item.scenario_group_name,
    }));
    setIsLoading(true);
    axios
      .post("/cm_open_loop_create_cm_cad_topology", {
        description: cadGroupName,
        list_of_grp: listOfGroups,
        model_name: selectValue,
        searchOptions: "{}",
        total_scenario_group: cartItems.length,
        fctw,
      })
      .then((response) => {
        if (response.status === 200) {
          console.log("Group created successfully", response);
          setOpenDialog(true);
        }
      })
      .catch((error) => {
        console.error("There was an error creating the group!", error);
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  const handleDialogClose = () => {
    setOpenDialog(false);
    history.push(`/cm_open_loop_topology?open-loop-type=${openLoopType}`);
  };

  useEffect(() => {
    if(modelOpts && !!modelOpts.length) {
      setSelectValue(modelOpts[0].value);
    }
  }, [])
  return (
    <Paper elevation={3} style={{ padding: "20px", marginTop: "20px" }}>
      <Box style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
        <Typography
          variant="h5"
          style={{
            display: "flex",
            justifyContent: "center",
            marginTop: "10px",
            marginBottom: "20px",
          }}
        >
          Topology Creation
        </Typography>
        <div>
               <Button
                 onClick={clearCart}
                 variant="outlined"
                 color="secondary"
                 style={{marginRight: '1rem'}}
                 disabled={cartItems.length === 0}
               >
                 Clear Cart
               </Button>
               <Button
                 onClick={handleClose}
                 variant="outlined"
                 color="secondary"
                 style={{marginRight: '1rem'}}
               >
                 Close
               </Button>
               </div>
      </Box>
      

      <Grid container spacing={3}>
        <Grid item xs={12} md={6}>
          <Card>
            <CardContent>
              {cartItems.length === 0 ? (
                <Typography variant="body2">
                  No items selected for grouping
                </Typography>
              ) : 
                <div style={{ height: "233px", overflow: 'auto'}}>
                  Selected <b>{cartItems.length}</b> Scenario Groups
                {cartItems.slice(0, 10).map((item, index) => (
                  <div
                    key={item.scenario_group_name}
                    style={{ display: "flex", flexDirection: "column" }}
                  >
                    <Typography variant="body2" style={{ flexGrow: 1 }}>
                      {item.scenario_group_name}
                    </Typography>
                    {index === 9 && cartItems.length > 10 && <div><Typography>{`and ${cartItems.length - 10} more`}</Typography></div>}
                  </div>
                ))}
                </div>}
            </CardContent>
          </Card>
        </Grid>
        <Grid item xs={12} md={6}>
          {cartItems.length > 0 && (
            <Card>
              <CardContent>
              {/* {modelOpts && !!modelOpts.length && (
                <FormControl
                  variant="outlined"
                  style={{ minWidth: 200, marginTop: "1rem" }}
                >
                  <Select
                    value={selectValue}
                    onChange={handleSelectChange}
                    MenuProps={{
                      getContentAnchorEl: null,
                      anchorOrigin: {
                        vertical: "bottom",
                        horizontal: "left",
                      },
                      transformOrigin: {
                        vertical: "top",
                        horizontal: "left",
                      },
                    }}
                  >
                    {modelOpts.map((option) => (
                      <MenuItem key={option._id} value={option.value}>
                        {option.value}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              )} */}
                <FormGroup>
                  <TextField
                    required
                    id="scenario-group-name"
                    label="CAD Topology Tag Name"
                    value={cadGroupName}
                    onChange={(e) => setCadGroupName(e.target.value)}
                    fullWidth
                    margin="normal"
                  />
                </FormGroup>
                {/* <FormGroup>
                  <TextField
                    InputProps={{
                      readOnly:true
                    }}
                    id="model-name"
                    label="Model Name"
                    value={cartItems[0].model_name}
                    fullWidth
                    margin="normal"
                  />
                </FormGroup> */}
                <Button
                  variant="contained"
                  color="primary"
                  fullWidth
                  style={{ marginTop: "10px" }}
                  onClick={handleCreateGroup}
                >
                  Create Topology
                </Button>
              </CardContent>
            </Card>
          )}
        </Grid>
      </Grid>

      <Dialog
        open={openDialog}
        onClose={handleDialogClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">{"Group Created"}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            The group has been created successfully.
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleDialogClose} color="primary" autoFocus>
            OK
          </Button>
        </DialogActions>
      </Dialog>
    </Paper>
  );
};

export default withRouter(TopologyCart);
